module.exports = __webpack_public_path__ + "static/media/test14_1.b021c323.png";